var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrecipitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M19 14.2422C20.206 13.435 21 12.0602 21 10.5C21 8.15643 19.2085 6.23129 16.9203 6.01937C16.4522 3.17213 13.9798 1 11 1C8.02024 1 5.54781 3.17213 5.07974 6.01937C2.79151 6.23129 1 8.15643 1 10.5C1 12.0602 1.79401 13.435 3 14.2422M7 17V19M7 11V13M15 17V19M15 11V13M11 19V21M11 13V15",
    stroke: "var(--stroke-0, #314158)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrecipitation);
export default __webpack_public_path__ + "static/media/precipitation.2dddc7751f3fb3e263f31ea25c8b7fab.svg";
export { ForwardRef as ReactComponent };